import { useAuthenticatedQuery, useAuthenticatedQueries } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

export function useMirandaQuery(
    url,
    queryKey,
    queryParameters,
    config = {},
    initialData,
) {
    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()
    const apiUrl = `miranda/${url}`

    queryKey.push({ network: selectedNetwork?.slug })
    return useAuthenticatedQuery(
        apiUrl,
        queryKey,
        { ...queryParameters },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
        initialData,
    )
}

export function useMirandaQueries(queriesData) {
    const { selectedNetwork } = useNetworksStateContext()

    const overridedQueriesData = queriesData.map(queryData => {
        queryData.queryKey.push({ network: selectedNetwork?.slug })
        const { enabled = true } = queryData.config
        const newConfig = {
            ...queryData.config,
            enabled: !!selectedNetwork?.slug && enabled,
        }

        return {
            url: `miranda/${queryData.url}`,
            queryKey: queryData.queryKey,
            queryParameters: { ...queryData.queryParameters, project: selectedNetwork?.slug },
            ...newConfig,
        }
    })

    return useAuthenticatedQueries(overridedQueriesData)
}